import { Browser, Device } from '@kakaopay-common/user-agent';

export const APP_PHASE = {
  LOCAL: 'local',
  MOCK: 'mock',
  BETA: 'beta',
  SANDBOX: 'sandbox',
  PRODUCTION: 'production',
};

type APP_PHASE_TYPE = typeof APP_PHASE[keyof typeof APP_PHASE];

export const MATRIX_DSN = process.env.MATRIX_DSN;

export const RELEASE = `${new Date().getTime()}`;

const PHASE = process.env.GATSBY_PHASE as APP_PHASE_TYPE;
export const isLocal = PHASE === APP_PHASE.LOCAL;
export const isMock = PHASE === APP_PHASE.MOCK;
export const isSandbox = PHASE === APP_PHASE.SANDBOX;
export const isBeta = PHASE === APP_PHASE.BETA;
export const isProduction = PHASE === APP_PHASE.PRODUCTION;

export const BASE_URL = process.env.GATSBY_BASE_URL;
export const TAG_PATH = `/tags/`;

export const SERVICE_PLATFORM_BASE_URL =
  process.env.GATSBY_SERVICE_PLATFORM_BASE_URL;
export const TENTH_SEC_BASE_URL = process.env.GATSBY_TENTH_SEC_BASE_URL;

export const MTS_URL = process.env.GATSBY_MTS_URL;
export const MTS_TERMS_URL = `${MTS_URL}/common/terms/list`;

export const PAY_LINK_BASE_URL = process.env.GATSBY_PAY_LINK_BASE_URL;

/** 증권 뉴스 도메인(news.kakaopaysec.com) */
export const PAYSEC_NEWS_URL = process.env.GATSBY_PAYSEC_NEWS_URL;

export const isPayApp = Browser.isKakaoPayApp();
export const isKakaoTalkApp = Browser.isKakaoTalkApp();
export const isPayWebview = Browser.isPayWebview();

export const isAndroid = Device.isAndroid();
export const isIos = Device.isIos();

/**
 * @description 실행된 환경이 서버인지 확인
 */
export const isServer = () => typeof window === 'undefined';
